import { z } from "zod";
import { schemes } from "../../schema-validation";
import { RouteMap } from "./customerReporting";

// base shifts used during reporting
export const reportsShiftSchema = z.object({
  employeeCheckID: schemes.uuid(),
  shiftID: schemes.mongoObjectId(),
  custom_name: z.string().nullish(),
  customerAccountID: z.string().nullish(),
  wcc_code: z.string().nullish(),
  name: z.string(),
  label: z.string(),
  amount: z.string(),
  description: z.string(),
  shift_date: z.string(),
  unformatted_amount: z.number(),
  unformatted_date: z.string().optional(),
  workLocationID: z.string().optional(),
  workLocation: z.string().optional(),
  hours: z.string().nullish(),
});

// shifts organized by some key -- work locationID, employeeID etc.
const reportsShiftsByKeySchema = z.record(
  z.string(),
  z.array(reportsShiftSchema)
);

// corrections to be displayed
const reportsShiftCorrectionSchema = z.object({
  type: z.string(),
  rate: z.string(),
  earned: z.string(),
});

export type ReportsShift = z.infer<typeof reportsShiftSchema>;
export type ReportsShiftsByKey = z.infer<typeof reportsShiftsByKeySchema>;
export type ReportsShiftCorrections = z.infer<
  typeof reportsShiftCorrectionSchema
>;

export const reportsShiftsYtdResponseSchema = z.object({
  hourlyWage: z.string(),
  otHours: z.string(),
  sickHours: z.string(),
  ytdHours: z.string(),
  ytdGross: z.string(),
  avgHours: z.string(),
  accrualBalance: z.string(),
  accruedSickTime: z.string(),
  employeeID: z.string(),
  customerAccount: z.string(),
  fullName: z.string(),
  title: z.string(),
  workState: z.string(),
});

export type ReportsShiftsYtdResponse = z.infer<
  typeof reportsShiftsYtdResponseSchema
>;
export type ReportsShiftsYtdResponseShape = {
  rows: z.infer<typeof reportsShiftsYtdResponseSchema>[];
} & {
  kind: RouteMap.shifts_ytd;
};
